module.exports = {"bannerFilters":[{"type":"text","name":"Title","placeholder":"Banner Title","field":"title"},{"type":"selector","name":"Origin","field":"iso_code","selectors":[{"label":"ALL","value":"","restriction":"PH"},{"label":"Passpod","value":"ID","restriction":"PH"},{"label":"Passpod PH","value":"PH"}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Misc/filterData.json
// module id = 1090
// module chunks = 0